module.exports = __webpack_public_path__ + "4c24b860bc79edef786c22739607f4a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_80.jpg
// module id = 1723
// module chunks = 5